/**
 * Vuex
 */

import Vue from 'vue'
import Vuex from 'vuex'

// 模块导出
import user from './_user.module'
import wxurl from './_wx.url.module'
import channel from './_channel.module'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    wxurl,
    channel
  }
})
